import React from 'react';
import styled from 'styled-components';
import { SectionParent, B1, H1, H2 } from '../../StyledComponents';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import CustomDevice from '../../../assets/v2/Test/custom-device.png';

const Section = styled(SectionParent)`
  background: #000000;
  padding-top: 1rem !important;
  padding-bottom: 0rem !important;
  @media (max-width: 520px) {
    padding-top: 1rem !important;
    padding-bottom: 0rem !important;
  }
`;
const Grid = styled.div`
  display: grid;
  padding-bottom: 3rem;
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 700px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
const GridItem = styled.div`
  justify-self: center;
  max-width: 80%;
  grid-column: span 2;
  @media (max-width: 768px) {
    margin-right: 0rem;
  }
  @media (max-width: 700px) {
    grid-column: span 3;
    margin-bottom: 3rem;
    display: grid;
    margin-right: 0rem;
    justify-items: center;
  }
`;
const SectionContent = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  width: 100%;
  color: #ffffff;
  padding-top: 0.5rem;
  text-align: justify;
  img {
    margin-top: 1rem;
  }
  @media (max-width: 700px) {
    padding-left: 0;
    text-align: justify;
    width: 90%;
  }
  @media (max-width: 520px) {
    width: 120%;
    text-align: center;
  }
`;
const SectionTitle = styled(H1)`
  padding-top: 2rem;
  @media (max-width: 520px) {
    text-align: left;
  }

  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.92;
  letter-spacing: normal;
  color: #ffffff;
`;

const TargetImage = styled(LazyLoadImage)`
  width: 115%;
  margin-top: 2rem;
  justify-self: center;
  @media (max-width: 768px) {
    width: 90%;
    margin-top: 0;
  }
`;
const ImgWrapper = styled.div`
  display: grid;
  align-items: center;
  @media (max-width: 768px) {
    grid-column: span 2;
  }
  @media (max-width: 700px) {
    grid-column: span 3;
  }
`;
export default () => (
  <Section>
    <Grid>
      <ImgWrapper>
        <TargetImage src={CustomDevice} />
      </ImgWrapper>

      <GridItem>
        <SectionTitle>Custom Device Emulators</SectionTitle>

        <SectionContent>
          We create custom device emulators (Android Studio AVDs) based on
          OEM-specific hardware configurations and OS versions. This emulator
          replicates the end device screen, appearance, input controls, and
          unique peripherals which helps you visualize the device and verify
          application behavior. You can also check for bugs, UX performance and
          validate fixes, if required. ISV vendors and application developers
          can test their applications on device emulators provisioned to
          specific deployment configurations and run them either locally or in
          the cloud across multiple emulated devices for backend load testing.
        </SectionContent>
      </GridItem>
    </Grid>
  </Section>
);
